import { Component, computed, input } from '@angular/core';
import type { ModelUploadStatusType } from 'shared';
import { ThemedIconComponent } from '../themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-upload-status-badge',
  imports: [ThemedIconComponent],
  templateUrl: './upload-status-badge.component.html',
  styleUrl: './upload-status-badge.component.scss',
})
export class UploadStatusBadgeComponent {
  readonly status = input.required<ModelUploadStatusType>();
  readonly percentage = input<number | undefined>();

  protected readonly badgeClass = computed(
    () => `upload-status-badge upload-status-badge--${this.status().toLowerCase()}`
  );

  protected readonly statusLabel = computed(() =>
    this.status() === 'Processing' ? 'Preparing' : this.status()
  );

  protected readonly isInProgress = computed(() => {
    const status = this.status();
    return (
      status === 'Preparing' ||
      status === 'Processing' ||
      status === 'Uploading' ||
      status === 'Finalizing'
    );
  });

  protected readonly isUploaded = computed(() => this.status() === 'Uploaded');

  protected readonly showPercentage = computed(
    () => this.isInProgress() && this.percentage() !== undefined
  );
}
